import { render, staticRenderFns } from "./CompanyInsurance.vue?vue&type=template&id=7699ae9b&scoped=true&"
import script from "./CompanyInsurance.vue?vue&type=script&lang=js&"
export * from "./CompanyInsurance.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInsurance.vue?vue&type=style&index=0&id=7699ae9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7699ae9b",
  null
  
)

export default component.exports